import { useAtom } from 'jotai'
import { userAtom } from '../state/userAtom'

/**
 * Custom hook to get the current user data.
 *
 * @returns {Object} An object containing the current user data.
 */
export const useCurrentUser = () => {
  const [user] = useAtom(userAtom)
  return { user }
}
